import { useContext } from 'react';
import { ThemeContext } from '../modules/acropolisCommon/provider/ThemeProvider';

const useTheme = () => {
    return useContext(ThemeContext)?.values;
};

export default useTheme;
